import React, { useCallback, useEffect, useRef, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Components/Pages/Home/Home";
import Navbar from "./Shared/Navbar";
import Dream from "./Components/Pages/Dream/Dream";
import FinancialPlan from "./Components/Pages/FinancialPlan/FinancialPlan";
import FinancisBetter from "./Components/Pages/FinancisBetter/FinancisBetter";
import Graph from "./Components/Pages/Graph/Graph";
import PersonalFinance from "./Components/Pages/PersonalFinance/PersonalFinance";
import ActionPoints from "./Components/Pages/ActionPoints/ActionPoints";
import InvestingBelief from "./Components/Pages/InvestingBelief/InvestingBelief";
import RiskReward from "./Components/Pages/RiskReward/RiskReward";
import MarketTiming from "./Components/Pages/MarketTiming/MarketTiming";
import Priorities from "./Components/Pages/Priorities/Priorities";
import DreamsIntoAction from "./Components/Pages/Dreams-into-Action/Dreams-into-Action";
import GetOnSamePage from "./Components/Pages/Get-On-Same-page/Get-On-Same-page";
import PlanYourGoals from "./Components/Pages/plan-your-goals/PlanYourGoals";
import { GoalTracker } from "./Components/Pages/GoalTracker/GoalTracker";
import { CentredVar } from "./Components/Pages/CentredVar/CentredVar";
import { PortfolioReview } from "./Components/Pages/PortfolioReview/PortfolioReview";
import { CustomizedActionPlan } from "./Components/Pages/CustomizedActionPlan/CustomizedActionPlan";
import { Table } from "./Components/Pages/Table/Table";
import { LogIn } from "./Components/Pages/LogIn/LogIn";
import { OtpVerification } from "./Components/Pages/OtpVerification/OtpVerification";
import { Share } from "./Components/Pages/Share/Share";
import { StayConnected } from "./Components/Pages/StayConnected/StayConnected";
import { AddressProof } from "./Components/Pages/AddressProof/AddressProof";
import { NeedFromYou } from "./Components/Pages/WhatWe‘llNeedFromYou/NeedFromYou";
import ActionPointsCopy from "./Components/Pages/ActionPointsCopy/ActionPointsCopy";

import socket from "./context/socket";
import axios from "axios";
import { PageNotFound } from "./Components/Pages/PageNotFound/PageNotFound";
import SubNav from "./Shared/SubNav";

import { BounceLoader, ClimbingBoxLoader, FadeLoader } from "react-spinners";
import { PortfolioReviewDetail } from "./Components/Pages/PortfolioReviewDetail/PortfolioReviewDetail";
import DigiLockerCallback from "./Components/Pages/AddressProof/modals/DigiLockerCallback";
import KeyActionPointTwo from "./Components/Pages/ActionPoints/ActionPointsTwo";
import MeetingNotification from "./Shared/notification/MeetingNotification";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientData } from "./redux/client/clientSlice";
import BseTable from "./Components/Pages/AddressProof/BseTable";
import ClientNotFound from "./Components/Pages/ClientNotFound/ClientNotFound";
import { debounce } from "lodash";
import api from "./utils/api";
import { Toaster } from "react-hot-toast";
import CallbackModal from "./Components/Pages/GoalTracker/modals/CallbackModal";

const App = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [clientData, setClientData] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  const queryParams = new URLSearchParams(window.location.search);
  const roomId = queryParams.get("clientId");
  const [isDarkMode, setIsDarkMode] = useState(false);
  const dispatch = useDispatch();


  const {
    clientData: Cdata,
    // loading,
    error,
  } = useSelector((state) => state.client);

  useEffect(() => {
    // axios
    //   .get(`advisor/${roomId}`)
    //   .then((response) => {
    //     setClientData(response.data); // Save client data
    //     console.log("data fatched",response.data)
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching data:", error);
    //     setClientData(false); // Set to false in case of error
    //   })
    //   .finally(() => {
    //     setLoading(false); // Stop loading when request finishes
    //   });

    try {
      // console.log("rgergerfger", Cdata);
      // setkycDoc(Cdata.kycDoc);
      setClientData(Cdata);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [Cdata]);

  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    dispatch(fetchClientData(roomId));
  }, [dispatch, roomId]);

  // const {
  //   clientData,
  //   loading,
  //   error,
  // } = useSelector((state) => state.client);

  // useEffect(() => {
  //   dispatch(fetchClientData(roomId));
  // }, [dispatch]);

  useEffect(() => {
    let clientId = roomId

    socket.on("connect", () => {
      console.log("✅ Advisor connected to socket");
    });

    // 🔥 ALWAYS EMIT (no dependency on connect)
    socket.emit("join", { room: clientId });
    socket.emit("init_session", { clientId });
    socket.emit("reconnect_advisor", { clientId });

    console.log("🔥 Advisor session started for:", clientId);


    socket.on("client_connected", ({ clid }) => {

      console.log('client_connected')
      // if (clientId == clid) {
      setIsConnected(true);
      // }

    })

    socket.on("client_already_connected", (data) => {
      console.log("🔁 Client already connected:", data);
      setIsConnected(true);
    });

    socket.on("client_disconnected", (data) => {
      console.log("🔴 Client disconnected:", data.clientId);
      // show “client offline” in UI
      setIsConnected(false);
    });



    socket.on("disconnect", () => {
      console.warn("⚠️ Advisor disconnected");
      setIsConnected(false);
    });

    // ✅ Handle manual window/tab close
    const handleBeforeUnload = () => {
      // Tell server advisor is ending session intentionally
      if (clientId) {
        socket.emit("end_session", { clientId });
        console.log("🧨 Advisor closed window, session ended for", clientId);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      socket.off("connect");
      socket.off("disconnect");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [roomId]);

  // --- Auth utils ---
  const extractRawJwt = (t) => {
    if (!t) return "";
    // Trim & remove any leading "Bearer " (even if repeated)
    let s = String(t).trim().replace(/^Bearer\s+/i, "");
    // If someone sent "Bearer Bearer ..." remove all repeats
    s = s.replace(/^Bearer\s+/i, "");
    // Final: only JWT remains
    return s.trim();
  };

  const isLikelyJwt = (t) => /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/.test(t);

  const setAxiosAuthHeader = (rawJwt) => {
    // Clean previous value to avoid accidental concatenation
    delete axios.defaults.headers.common["Authorization"];
    if (rawJwt) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${rawJwt}`;
    }
  };
  const getAdvisorCRMId = async (token) => {
    if (token !== "") {
      const response = await api.get("advisor/get_advisorId/token")
      return response.data
    }
  }
  // useEffect(() => {
  //   const token = localStorage.getItem("authToken");
  //   if (token) {
  //     const advisorID = getAdvisorCRMId(token);
  //   }
  // }, []); // ✅ run only once on mount

  const [advisorId, setAdvisorId] = useState(null);

  // 🔹 Step 1: Get advisor ID from token once on mount
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      getAdvisorCRMId(token).then((id) => {
        setAdvisorId(id);
      });
    }
  }, [roomId]);

  // 🔹 Step 2: Debounced function to emit advisor ID to socket
  const sendAdvisorToServer = useCallback(
    debounce((id) => {
      if (id) {
        socket.emit("advisor_pass", { room: roomId, advisorCRM_Id: id });
        console.log("🛰️ Advisor ID emitted:", id);
      }
    }, 500),
    [roomId]
  );

  // 🔹 Step 3: Whenever advisorId changes → send to socket
  useEffect(() => {
    if (advisorId) {
      sendAdvisorToServer(advisorId);
    }
  }, [advisorId, sendAdvisorToServer]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const refToken = params.get("refToken");
    console.log(refToken, "refToken")

    if (refToken && refToken !== "null") {
      const raw = extractRawJwt(refToken);
      if (!isLikelyJwt(raw)) {
        console.warn("Ref token did not look like a JWT.");
      }
      localStorage.setItem("authToken", raw); // store RAW token only
      setAxiosAuthHeader(raw);

      // clean URL (remove ?refToken=...)
      params.delete("refToken");
      const q = params.toString();
      const cleanUrl = q ? `${window.location.pathname}?${q}` : window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
    } else {
      // No refToken in URL → try stored
      const storedRaw = localStorage.getItem("authToken");
      if (storedRaw) {
        setAxiosAuthHeader(storedRaw);
      } else {
        window.location.replace("https://crm.finedge.in/?logout=true");
      }
    }
  }, []);



  // useEffect(() => {
  //   const normalizeBearer = (t) =>
  //     !t ? "" : t.startsWith("Bearer ") ? t : `Bearer ${t}`;

  //   const params = new URLSearchParams(window.location.search);
  //   const refToken = params.get("refToken");

  //   if (refToken && refToken !== "null") {
  //     const authToken = normalizeBearer(refToken);
  //     localStorage.setItem("authToken", authToken);
  //     axios.defaults.headers.common["Authorization"] = authToken;

  //     // remove ?refToken=... from URL (avoid leftover '?')
  //     params.delete("refToken");
  //     const q = params.toString();
  //     const cleanUrl = q ? `${window.location.pathname}?${q}` : window.location.pathname;
  //     window.history.replaceState({}, document.title, cleanUrl);
  //   } else {
  //     // no refToken in URL → use stored token or redirect
  //     const stored = localStorage.getItem("authToken");
  //     if (stored) {
  //       axios.defaults.headers.common["Authorization"] = stored;
  //     } else {
  //       window.location.replace("https://crm-dia.netlify.app/sign-in");
  //     }
  //   }
  // }, []);



  // if (loading) {
  //   return (
  //     <div
  //       className="d-flex justify-content-center align-items-center"
  //       style={{
  //         position: "fixed",
  //         top: "50%",
  //         left: "50%",
  //         transform: "translate(-50%, -50%)",
  //         zIndex: 9999,
  //       }}
  //     >
  //       <FadeLoader color="#23674B" size={50} />
  //     </div>
  //   );
  // }

  return (
    // <BrowserRouter>
    //   {!clientData || (!roomId && <PageNotFound />)}
    //   {clientData && (
    //     <Navbar
    //       isConnected={isConnected}
    //       isDarkMode={isDarkMode}
    //       setIsDarkMode={setIsDarkMode}
    //     />
    //   )}
    //   <main>
    //     {clientData && <SubNav isConnected={isConnected} />}
    //     <Routes>
    //       {clientData ? (
    //         <>
    //           <Route path="/" element={<Home isConnected={isConnected} />} />
    //           <Route path="/dream" element={<Dream />} />
    //           <Route path="/financial-plan" element={<FinancialPlan />} />
    //           <Route path="/financial-better" element={<FinancisBetter />} />
    //           <Route
    //             path="/graph"
    //             element={<Graph isDarkMode={isDarkMode} />}
    //           />
    //           <Route path="/personal-finance" element={<PersonalFinance />} />
    //           <Route path="/action-points" element={<ActionPoints />} />
    //           <Route path="/investing-belief" element={<InvestingBelief />} />
    //           <Route path="/risk-reward" element={<RiskReward />} />
    //           <Route path="/market-timing" element={<MarketTiming />} />
    //           <Route path="/priorities" element={<Priorities />} />
    //           <Route
    //             path="/dreams-into-action"
    //             element={<DreamsIntoAction />}
    //           />
    //           <Route path="/get-on-same-page" element={<GetOnSamePage />} />
    //           <Route path="/plan-your-goals" element={<PlanYourGoals />} />
    //           <Route
    //             path="/goal-tracker"
    //             element={
    //               <GoalTracker
    //                 isDarkMode={isDarkMode}
    //                 isConnected={isConnected}
    //               />
    //             }
    //           />
    //           <Route
    //             path="/centred-var"
    //             element={<CentredVar isDarkMode={isDarkMode} />}
    //           />
    //           <Route
    //             path="/bse-table"
    //             element={<BseTable isDarkMode={isDarkMode} />}
    //           />
    //           <Route path="/portfolio-review" element={<PortfolioReview />} />
    //           <Route
    //             path="/dashboard/portfolio-review-detail/:id"
    //             element={<PortfolioReviewDetail />}
    //           />
    //           <Route
    //             path="/customized-action-plan"
    //             element={<CustomizedActionPlan />}
    //           />
    //           <Route path="/table" element={<Table />} />
    //           <Route path="/login" element={<LogIn />} />
    //           <Route path="/otp-verification" element={<OtpVerification />} />
    //           <Route path="/share" element={<Share />} />
    //           <Route path="/stay-connected" element={<StayConnected />} />
    //           <Route path="/address-proof" element={<AddressProof />} />

    //           <Route
    //             path="/callback-digiLocker"
    //             element={<DigiLockerCallback />}
    //           />
    //           <Route
    //             path="/what-we‘ll-need-from-you"
    //             element={<NeedFromYou />}
    //           />
    //           <Route
    //             path="/action-points-copy"
    //             element={<ActionPointsCopy />}
    //           />
    //         </>
    //       ) : (
    //         <Route path="*" element={<PageNotFound />} />
    //       )}
    //     </Routes>
    //   </main>
    //   <MeetingNotification />
    // </BrowserRouter>

    <BrowserRouter>
      {/* Global routes that don't need auth */}
      {/* <Routes>
      <Route path="/bse-table" element={<BseTable isDarkMode={isDarkMode} />} />
    </Routes> */}
      <Routes>
        {window.location.pathname === "/bse-table" &&
          <Route
            path="*"
            element={
              window.location.pathname === "/bse-table" ? (
                <BseTable isDarkMode={isDarkMode} />
              ) : (
                <PageNotFound />
              )
            }
          />
        }
      </Routes>
      {/* Routes that need clientData and roomId */}
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 9999,
          }}
        >
          <FadeLoader color="#23674B" size={50} />
        </div>
      ) : error === "Client not found" ? (
        <ClientNotFound />
      ) : clientData && roomId ? (
        <>
          {
            <>
              <Navbar
                isConnected={isConnected}
                isDarkMode={isDarkMode}
                setIsDarkMode={setIsDarkMode}
              />
              <SubNav isConnected={isConnected} />
            </>
          }
          <main>
            <Toaster position="top-right" reverseOrder={false} />
            <Routes>
              <Route path="/" element={<Home isConnected={isConnected} />} />
              <Route path="/dream" element={<Dream  isDarkMode={isDarkMode}/>} />
              <Route path="/financial-plan" element={<FinancialPlan  isDarkMode={isDarkMode}/>} />
              <Route path="/financial-better" element={<FinancisBetter />} />
              <Route path="/my-cash-flow" element={<Graph isDarkMode={isDarkMode} />} />
              <Route path="/personal-finance" element={<PersonalFinance />} />
              <Route path="/key-action-points" element={<ActionPoints />} />
              <Route path="/investing-belief" element={<InvestingBelief />} />
              <Route path="/risk-reward" element={<RiskReward />} />
              <Route path="/long-term-investing" element={<MarketTiming />} />
              <Route path="/priorities" element={<Priorities />} />
              <Route path="/dreams-into-action" element={<DreamsIntoAction />} />
              <Route path="/get-on-same-page" element={<GetOnSamePage isConnected={isConnected} />} />
              <Route path="/plan-your-goals" element={<PlanYourGoals />} />
                  <Route path="/callback" element={<CallbackModal/>} />
              <Route
                path="/goal-tracker"
                element={<GoalTracker isDarkMode={isDarkMode} isConnected={isConnected} />}
              />
              <Route
                path="/my-investment"
                element={<CentredVar isDarkMode={isDarkMode} />}
              />
              <Route path="/portfolio-review" element={<PortfolioReview />} />
              <Route
                path="/portfolio-review-detail"
                element={<PortfolioReviewDetail />}
              />
              <Route path="/customized-action-plan" element={<CustomizedActionPlan />} />
              <Route path="/capital-gain-report" element={<Table />} />
              <Route path="/login" element={<LogIn />} />
              <Route path="/otp-verification" element={<OtpVerification />} />
              <Route path="/refer-friends" element={<Share />} />
              <Route path="/stay-connected" element={<StayConnected />} />
              <Route path="/address-proof" element={<AddressProof isConnected={isConnected}/>} />
              <Route path="/callback-digiLocker" element={<DigiLockerCallback />} />
              <Route path="/what-we-will-need-from-you" element={<NeedFromYou />} />
              <Route path="/action-points-copy" element={<ActionPointsCopy />} />

              {window.location.pathname !== "/bse-table" && <Route path="*" element={<PageNotFound />} />}
            </Routes>
          </main>
        </>
      ) :

        window.location.pathname === "/bse-table" ?
          <Route
            path="*"
            element={
              window.location.pathname === "/bse-table" &&
              <BseTable isDarkMode={isDarkMode} />

            }
          /> :
          (
            <Routes>
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          )}

      <MeetingNotification />
    </BrowserRouter>

  );
};

export default App;
